// VNEC v9 — pages/kho.js
// Trang Tồn kho với 2 tab:
//   Tab 1: Tồn kho hiện tại (ton_kho join vat_tu_catalog)
//   Tab 2: Danh mục vật tư (vat_tu_catalog full + tổng nhập/xuất + giao dịch cuối qua RPC)
import { supabase, rpc } from '../lib/supabase.js';
import { formatVND, esc } from '../lib/forms.js';
import { ok, err } from '../components/toast.js';

let _state = { tab: 'ton-kho', searchTerm: '', filterNhom: '', filterStatus: '' };

export async function renderKho() {
  window.__pageInit = init;
  return `
    <div class="page">
      <div class="page-header">
        <h1>Tồn kho vật tư</h1>
        <div class="page-actions">
          <a href="#/vat-tu/new" class="btn btn-primary btn-sm" id="kho-add-btn" style="display:none">+ Thêm vật tư</a>
        </div>
      </div>

      <div class="kho-tabs" id="kho-tabs">
        <button class="kho-tab on" data-tab="ton-kho">📦 Tồn kho hiện tại <span class="kho-tab-cnt" id="cnt-ton">—</span></button>
        <button class="kho-tab" data-tab="danh-muc">📋 Danh mục vật tư <span class="kho-tab-cnt" id="cnt-dm">—</span></button>
      </div>

      <div id="kho-content"><div class="loading center" style="padding:2rem">Đang tải...</div></div>
    </div>`;
}

async function init() {
  // Show "Add" button only for admin
  let isAdmin = false;
  const { data: { user } } = await supabase.auth.getUser();
  if (user) {
    const { data: prof } = await supabase.from('user_profiles').select('role').eq('id', user.id).maybeSingle();
    isAdmin = prof?.role === 'admin';
    if (isAdmin) {
      document.getElementById('kho-add-btn').style.display = '';
    }
  }
  _state.isAdmin = isAdmin;

  document.querySelectorAll('#kho-tabs .kho-tab').forEach(btn => {
    btn.addEventListener('click', () => switchTab(btn.dataset.tab));
  });

  await Promise.all([loadTonKho(), loadDanhMuc()]);
}

function switchTab(tab) {
  _state.tab = tab;
  document.querySelectorAll('#kho-tabs .kho-tab').forEach(b => b.classList.toggle('on', b.dataset.tab === tab));
  if (tab === 'ton-kho') renderTonKhoContent();
  else renderDanhMucContent();
}

// ════════════════════════════════════════════════════════════
// TAB 1: Tồn kho hiện tại (logic cũ)
// ════════════════════════════════════════════════════════════
let _tonKhoData = null;

async function loadTonKho() {
  const [tkRes, vtRes] = await Promise.all([
    supabase.from('ton_kho').select('ma_vat_tu, so_luong_ton, gia_bq, gia_tri_ton, updated_at').order('ma_vat_tu').limit(1000),
    supabase.from('vat_tu_catalog').select('ma_vat_tu, ten_vat_tu, don_vi, nhom').limit(5000)
  ]);
  if (tkRes.error) { _tonKhoData = { error: tkRes.error.message }; return; }

  const vtMap = {};
  (vtRes.data || []).forEach(v => { vtMap[v.ma_vat_tu] = v; });

  _tonKhoData = (tkRes.data || []).map(r => ({ ...r, vat_tu: vtMap[r.ma_vat_tu] || null }));
  document.getElementById('cnt-ton').textContent = _tonKhoData.filter(r => Number(r.so_luong_ton) > 0).length;
  if (_state.tab === 'ton-kho') renderTonKhoContent();
}

function renderTonKhoContent() {
  const wrap = document.getElementById('kho-content');
  if (!_tonKhoData) { wrap.innerHTML = '<div class="loading">Đang tải...</div>'; return; }
  if (_tonKhoData.error) { wrap.innerHTML = `<div class="error-box">Lỗi: ${_tonKhoData.error}</div>`; return; }

  const data = _tonKhoData;
  const totalGT = data.reduce((s, r) => s + Number(r.gia_tri_ton || 0), 0);
  const totalItems = data.filter(r => Number(r.so_luong_ton) > 0).length;

  wrap.innerHTML = `
    <div class="vt-stats">
      <div class="vt-stat"><div class="l">Tổng GT tồn</div><div class="v">${formatVND(totalGT)} đ</div></div>
      <div class="vt-stat"><div class="l">Số VT có tồn</div><div class="v">${totalItems}</div></div>
      <div class="vt-stat"><div class="l">Tổng records</div><div class="v">${data.length}</div></div>
    </div>
    <div class="vt-toolbar">
      <input type="search" id="tk-search" class="vt-search" placeholder="🔍 Tìm theo mã, tên...">
    </div>
    <div class="card">
      <div class="table-wrap">
        <table class="table" id="kho-table">
          <thead><tr>
            <th>Mã VT</th><th>Tên vật tư</th><th>Nhóm</th>
            <th class="num">SL tồn</th><th>ĐVT</th>
            <th class="num">Giá BQ</th><th class="num">GT tồn</th>
            <th>Cập nhật</th>
          </tr></thead>
          <tbody id="kho-tbody"></tbody>
        </table>
      </div>
    </div>`;

  const renderRows = () => {
    const term = (document.getElementById('tk-search').value || '').toLowerCase();
    const filtered = data.filter(r =>
      !term || r.ma_vat_tu.toLowerCase().includes(term) ||
      (r.vat_tu?.ten_vat_tu || '').toLowerCase().includes(term)
    );
    const tbody = document.getElementById('kho-tbody');
    if (!filtered.length) { tbody.innerHTML = '<tr><td colspan="8" class="muted center">Trống.</td></tr>'; return; }
    tbody.innerHTML = filtered.map(r => `
      <tr>
        <td><span class="vt-ma">${esc(r.ma_vat_tu)}</span></td>
        <td>${esc(r.vat_tu?.ten_vat_tu || '—')}</td>
        <td class="small">${esc(r.vat_tu?.nhom || '')}</td>
        <td class="num">${formatVND(r.so_luong_ton)}</td>
        <td class="small">${esc(r.vat_tu?.don_vi || '')}</td>
        <td class="num">${formatVND(r.gia_bq)}</td>
        <td class="num bold">${formatVND(r.gia_tri_ton)} đ</td>
        <td class="small muted">${r.updated_at ? new Date(r.updated_at).toLocaleDateString('vi-VN') : '—'}</td>
      </tr>`).join('');
  };
  renderRows();
  let t;
  document.getElementById('tk-search').addEventListener('input', () => { clearTimeout(t); t = setTimeout(renderRows, 200); });
}

// ════════════════════════════════════════════════════════════
// TAB 2: Danh mục vật tư
// ════════════════════════════════════════════════════════════
let _dmData = null;

async function loadDanhMuc() {
  try {
    const data = await rpc('get_vat_tu_catalog');
    _dmData = data || [];
    document.getElementById('cnt-dm').textContent = _dmData.length;
  } catch (e) {
    _dmData = { error: e.message };
  }
  if (_state.tab === 'danh-muc') renderDanhMucContent();
}

function renderDanhMucContent() {
  const wrap = document.getElementById('kho-content');
  if (!_dmData) { wrap.innerHTML = '<div class="loading">Đang tải...</div>'; return; }
  if (_dmData.error) { wrap.innerHTML = `<div class="error-box">Lỗi: ${_dmData.error}</div>`; return; }

  const data = _dmData;
  const totalVT = data.length;
  const activeVT = data.filter(v => v.is_active).length;
  const haveStock = data.filter(v => Number(v.so_luong_ton || 0) > 0).length;
  const totalStockValue = data.reduce((s, v) => s + Number(v.gia_tri_ton || 0), 0);
  const allNhom = [...new Set(data.map(v => v.nhom).filter(Boolean))];

  wrap.innerHTML = `
    <div class="vt-stats">
      <div class="vt-stat"><div class="l">Tổng vật tư</div><div class="v">${totalVT}</div></div>
      <div class="vt-stat"><div class="l">Đang sử dụng</div><div class="v">${activeVT}</div></div>
      <div class="vt-stat"><div class="l">Có tồn kho</div><div class="v">${haveStock}</div></div>
      <div class="vt-stat"><div class="l">Tổng giá trị tồn</div><div class="v">${formatVND(totalStockValue)} đ</div></div>
    </div>

    <div class="vt-toolbar">
      <input type="search" id="dm-search" class="vt-search" placeholder="🔍 Tìm theo mã, tên, nhóm vật tư...">
      <select id="dm-nhom" class="vt-filter">
        <option value="">Tất cả nhóm</option>
        ${allNhom.map(n => `<option value="${esc(n)}">${esc(n)}</option>`).join('')}
      </select>
      <select id="dm-status" class="vt-filter">
        <option value="">Tất cả trạng thái</option>
        <option value="active">Đang sử dụng</option>
        <option value="inactive">Đã vô hiệu hóa</option>
      </select>
    </div>

    <div class="card">
      <div class="table-wrap">
        <table class="table" id="dm-table">
          <thead><tr>
            <th style="width:140px">Mã VT</th>
            <th>Tên vật tư</th>
            <th style="width:55px">ĐVT</th>
            <th style="width:100px">Nhóm</th>
            <th class="num" style="width:110px">Tồn HT</th>
            <th class="num" style="width:110px">Giá BQ</th>
            <th class="num" style="width:100px">Tổng nhập</th>
            <th class="num" style="width:100px">Tổng xuất</th>
            <th style="width:140px">Giao dịch cuối</th>
            <th style="width:100px"></th>
          </tr></thead>
          <tbody id="dm-tbody"></tbody>
        </table>
      </div>
    </div>`;

  const renderRows = () => {
    const term = (document.getElementById('dm-search').value || '').toLowerCase();
    const fNhom = document.getElementById('dm-nhom').value;
    const fStatus = document.getElementById('dm-status').value;

    const filtered = data.filter(v => {
      if (term) {
        const hay = (v.ma_vat_tu + ' ' + (v.ten_vat_tu || '') + ' ' + (v.nhom || '')).toLowerCase();
        if (!hay.includes(term)) return false;
      }
      if (fNhom && v.nhom !== fNhom) return false;
      if (fStatus === 'active' && !v.is_active) return false;
      if (fStatus === 'inactive' && v.is_active) return false;
      return true;
    });

    const tbody = document.getElementById('dm-tbody');
    if (!filtered.length) {
      tbody.innerHTML = '<tr><td colspan="10" class="muted center" style="padding:1.5rem">Không có vật tư phù hợp.</td></tr>';
      return;
    }

    tbody.innerHTML = filtered.map(v => {
      const ton = Number(v.so_luong_ton || 0);
      const tonCls = ton === 0 ? 'ton-zero' : ton < 100 ? 'ton-low' : 'ton-ok';
      const inactive = !v.is_active ? 'vt-row-inactive' : '';
      const lastTx = formatLastTx(v);
      return `
      <tr class="${inactive}">
        <td><span class="vt-ma">${esc(v.ma_vat_tu)}</span></td>
        <td class="small">${esc(v.ten_vat_tu || '—')}</td>
        <td class="small">${esc(v.don_vi || '')}</td>
        <td>${nhomBadge(v.nhom)}</td>
        <td class="num ${tonCls}">${ton > 0 ? formatVND(ton) : '0'}</td>
        <td class="num ${ton === 0 ? 'ton-zero' : ''}">${ton > 0 ? formatVND(v.gia_bq || 0) : '—'}</td>
        <td class="num small" style="color:#085041">${formatVND(v.tong_nhap || 0)}</td>
        <td class="num small" style="color:#A32D2D">${formatVND(v.tong_xuat || 0)}</td>
        <td class="small">${lastTx}</td>
        <td class="vt-act">
          ${_state.isAdmin ? `<a href="#/vat-tu/${encodeURIComponent(v.ma_vat_tu)}" class="btn btn-ghost btn-xs">Sửa</a>` : ''}
        </td>
      </tr>`;
    }).join('');
  };

  renderRows();
  let t;
  document.getElementById('dm-search').addEventListener('input', () => { clearTimeout(t); t = setTimeout(renderRows, 200); });
  document.getElementById('dm-nhom').addEventListener('change', renderRows);
  document.getElementById('dm-status').addEventListener('change', renderRows);
}

function nhomBadge(nhom) {
  if (!nhom) return '';
  const lower = nhom.toLowerCase();
  let cls = 'n-other';
  if (lower.includes('xi') || lower.includes('xm')) cls = 'n-xm';
  else if (lower.includes('thép') || lower.includes('thep') || lower.includes('th')) cls = 'n-th';
  else if (lower.includes('cát') || lower.includes('cat') || lower.includes('đá') || lower.includes('da')) cls = 'n-cd';
  else if (lower.includes('gạch') || lower.includes('gach') || lower.includes('gh')) cls = 'n-gh';
  return `<span class="vt-nhom ${cls}">${esc(nhom)}</span>`;
}

function formatLastTx(v) {
  if (!v.last_tx_loai) return '<span class="muted">— Chưa GD</span>';
  const arrow = v.last_tx_loai === 'nhap' ? '↗' : '↘';
  const color = v.last_tx_loai === 'nhap' ? '#085041' : '#A32D2D';
  const label = v.last_tx_loai === 'nhap' ? 'Nhập' : 'Xuất';
  const date = v.last_tx_date ? new Date(v.last_tx_date).toLocaleDateString('vi-VN', { day: '2-digit', month: '2-digit' }) : '';
  return `<span style="color:${color}">${arrow} ${label} <b>${formatVND(v.last_tx_qty || 0)}</b></span> · ${date}`;
}
